var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sentinel"},[(_vm.loading)?_c('div',{staticClass:"sentinel__loader"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }